import { useRecentChatMessagesQuery, useworkspaceAuthMeV2Query } from '@/types/generated/graphql';
import { toSidebarRows } from '@modules/members/utils/to-sidebar-rows';
import { cacheOnly } from '@shared/constants';
import { useMemo } from 'react';

const sidebar_rows = 4;
const member_rows = sidebar_rows - 1;

export function useWorkspaceMembers() {
  const { data, loading } = useRecentChatMessagesQuery({ variables: { limit: member_rows } });

  const { data: workspaceAuthMe } = useworkspaceAuthMeV2Query(cacheOnly);
  const selfWorkspaceMemberId = workspaceAuthMe?.workspaceAuthMeV2?.data?.currentUserWorkspace?.id;

  const rows = data?.recentChatMessages?.data;
  const { members, allMembers } = useMemo(
    () => toSidebarRows(rows, selfWorkspaceMemberId),
    [rows, selfWorkspaceMemberId]
  );

  return {
    data: { data: members },
    allMembers,
    hasNextPage: data?.recentChatMessages?.cursor?.hasNextPage || false,
    initialLoading: loading,
  };
}
